import React, { useState, useEffect } from "react"
import styled from "styled-components"
import AnimatedNumber from "react-animated-number"
import firebase from "gatsby-plugin-firebase"

import { Section, Container } from "../global"

const SocialProof = () => {
  const [totalSuns, setTotalSuns] = useState(0)
  const [sunsToday, setSunsToday] = useState(null)

  let today = new Date()
  let dd = today.getDate()
  let mm = today.getMonth() + 1
  const yyyy = today.getFullYear()
  if (dd < 10) {
    dd = `0${dd}`
  }
  if (mm < 10) {
    mm = `0${mm}`
  }
  today = `${mm}/${dd}/${yyyy}`

  useEffect(() => {
    firebase
      .firestore()
      .collection("days")
      .get()
      .then((querySnapshot) => {
        setTotalSuns(querySnapshot.docs.length)
      })
      .catch((error) => {})

    firebase
      .firestore()
      .collection("days")
      .where("createdAt", "==", today)
      .get()
      .then((querySnapshot) => {
        setSunsToday(querySnapshot.docs.length)
      })
      .catch((error) => {})
  }, [today])

  return (
    <Section id="communityproof">
      <StyledContainer>
        <Subtitle>Proof of work</Subtitle>
        <SectionTitle>
          <AnimatedNumber
            style={{
              transition: ".8s ease-out",
              transitionProperty: "background-color, color",
            }}
            frameStyle={(perc) =>
              perc === 100 ? {} : { backgroundColor: "#FFDE59" }
            }
            stepPrecision={0}
            value={totalSuns}
            duration={8000}
            formatValue={(n) => `☀️ ${n} suns added — and counting`}
          />
        </SectionTitle>
        {sunsToday > 0 && (
          <TodayLine>
            {sunsToday} {sunsToday === 1 ? "sun is" : "suns are"} already up
            today. Yours fits right in.
          </TodayLine>
        )}
        <TestimonialsGrid>
          <div className="testimonial-card">
            <div className="text">
              Day helps me stick to my fitness routine to look and feel great!
              It's the app that just works for me.
              <i className="fas fa-quote-right quote"></i>
            </div>
            <br />
            <br />
            <div className="footer">
              <div className="image"></div>
              <h3 className="person">Marie</h3>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="text">
              Dailyness has transformed my life. Day helps me keep my streak
              alive so I know I'm always taking a step forward.{" "}
              <i className="fas fa-quote-right quote"></i>
            </div>
            <br />
            <br />
            <div className="footer">
              <div className="image2"></div>
              <h3 className="person">TheSchnaz</h3>
            </div>
          </div>
        </TestimonialsGrid>
        <RatingsLine>
          Find Day on the App Store and Google Play — the community would love
          to cheer you on.
        </RatingsLine>
      </StyledContainer>
    </Section>
  )
}

export default SocialProof

const StyledContainer = styled(Container)``

const SectionTitle = styled.h3`
  color: ${(props) => props.theme.color.primary};
  display: flex;
  justify-content: center;
  margin: 0 auto 16px;
  text-align: center;
`

const Subtitle = styled.h5`
  font-size: 16px;
  color: ${(props) => props.theme.color.accent};
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-align: center;
`

const TodayLine = styled.p`
  text-align: center;
  color: ${(props) => props.theme.color.black.light};
  font-size: 17px;
  margin: 0 auto;
  max-width: 480px;
`

const TestimonialsGrid = styled.div`
  max-width: 870px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0 auto;
  grid-column-gap: 40px;
  grid-row-gap: 35px;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
    padding: 0 64px;
  }
`

const RatingsLine = styled.p`
  text-align: center;
  color: ${(props) => props.theme.color.black.lightest};
  font-size: 14px;
  margin: 48px auto 0;
`
